const CopTemplateComponent = () => import('@/views/cop/CopTemplate/CopTemplateView')

export default [
    {
        path:'/CopTemplateIndex',
        name:'CopTemplateComponent',
        component:CopTemplateComponent
    }
]